import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { userActions } from '../actions';
import { generalActions } from '../actions';

class LoginPage extends React.Component {
  constructor(props) {
    super(props);

    // reset login status
    this.props.dispatch(userActions.logout());

    this.state = {
      username: '',
      password: '',
      submitted: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {}

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { username, password } = this.state;
    const { dispatch } = this.props;
    if (username && password) {
      dispatch(userActions.login(username, password));
      // dispatch(generalActions.getNotification());
    }
  }

  render() {
    const { loggingIn } = this.props;
    const { username, password, submitted } = this.state;
    return (
      <div className="container">
        <div className="login-box">
          <div className="row">
            <div className="col-md-6">
              <div class="login-box-cover" style={{background: 'linear-gradient(rgba(0,0,0,.3),rgba(0,0,0,.3)), url('+require('../assets/img/bg_login.jpg')+') no-repeat center', backgroundSize: 'cover'}}>
              <div class="content">
                <img src={require('../assets/img/logo_login.png')} class="img-fluid" alt="Logo"/>
              </div>
            </div>
            </div>
            <div className="col-md-6">
              <div className="login-box-forms">
                <div className="content">
                  <form name="form" onSubmit={this.handleSubmit} className="d-flex flex-column h-100">
                    <h1>Admin Login</h1>
                    <div className="mb-auto">
                      <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                        <label htmlFor="username">Username</label>
                        <input
                          type="text"
                          className="form-control"
                          name="username"
                          value={username}
                          onChange={this.handleChange}
                        />
                        {submitted &&
                          !username && <small className="text-muted">Username is required</small>}
                      </div>
                      <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          name="password"
                          value={password}
                          onChange={this.handleChange}
                        />
                        {submitted &&
                          !password && <small className="text-muted">Password is required</small>}
                      </div>
                      <Link to={`${process.env.PUBLIC_URL}/forgot`} className="pull-right">
                        Forgot password?
                      </Link>
                    </div>
                    <button className="btn btn-success">Login</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn
  };
}

const connectedLoginPage = connect(mapStateToProps)(LoginPage);
export { connectedLoginPage as LoginPage };



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js